import { useEffect } from 'react';
import { track } from '../utils/analytics';

/**
 * Logs a `section_view` event the first time each section scrolls into view.
 * Cheap scroll-depth signal for the single-page home: tells us how far down
 * people actually get, section by section.
 */
export default function useSectionViews(ids, { threshold = 0.35 } = {}) {
    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') return undefined;
        const seen = new Set();
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting || seen.has(entry.target.id)) return;
                seen.add(entry.target.id);
                track('section_view', { section: entry.target.id });
                observer.unobserve(entry.target);
            });
        }, { threshold });

        ids.forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });
        return () => observer.disconnect();
    // ids is a static list per page; re-running on identity changes would double-fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
